/* Lior Genève — product page behaviour (from references/html-v4/concept-1.html), wired to the Shopify cart. */
(() => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const set = (s, t) => $$(s).forEach(el => el.textContent = t);
  const cfgEl = $('[data-lg-config]');
  if (!cfgEl) return;
  const CFG = JSON.parse(cfgEl.textContent);
  const euro = cents => { const n = Math.round(cents) / 100; return n.toLocaleString('fr-FR', {style: 'currency', currency: 'EUR', minimumFractionDigits: n % 1 ? 2 : 0}); };
  const ampoules = q => `${q} ampoule${q > 1 ? 's' : ''}`;
  const FREE_SHIP = CFG.freeShip || 0; // 0 = shipping always free
  const freeFor = cents => cents >= FREE_SHIP;
  // Each lot is a Shopify variant. "price" is what the buyer pays for the lot (the bundle price, reached at checkout
  // through the matching automatic discount); "compare" is the reference: the same number of ampoules at the unit price.
  const BUNDLES = CFG.bundles;
  const UPSELLS = CFG.upsells || [];
  const upsellByVariant = Object.fromEntries(UPSELLS.map(p => [p.id, p]));
  const upsellLabels = CFG.upsellLabels || {};
  const RECOMMENDATIONS = CFG.recommendations || [];
  const relatedByVariant = Object.fromEntries(RECOMMENDATIONS.map(p => [p.id, p]));
  const relatedForms = $$('[data-related-form]');
  const relatedPending = new Set();
  const byVariant = {};
  Object.entries(BUNDLES).forEach(([q, b]) => { b.qty = +q; byVariant[b.id] = b; });
  // Copy per lot (tag, duration, pitch, offer name, cart note) is rendered by Liquid on the buttons.
  $$('.bundle-segment [data-bundle]').forEach(btn => Object.assign(BUNDLES[btn.dataset.qty] || {}, {tag: btn.dataset.lotTag, dur: btn.dataset.lotDur, pitch: btn.dataset.lotPitch, offer: btn.dataset.lotOffer, badge: btn.dataset.lotBadge, note: btn.dataset.lotNote}));
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = n => String(n).padStart(2, '0');
  const CUTOFF = 0; // Preparation takes 1–3 working days; no same-day dispatch promise.
  // Developer preview only: invented viewer/stock numbers and a countdown that restarts every midnight, exactly as in
  // the prototype. Shown in the theme editor, on any preview of an unpublished theme (Shopify.theme.role comes from
  // content_for_header) and with ?lg_demo=1 — never for regular visitors of the live theme. ?lg_demo=1 is remembered in
  // this browser, so later visits to the plain URL keep the preview; ?lg_demo=0 forgets it. See docs/HANDOFF_DEVELOPER.md.
  const draftTheme = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  const demoParam = new URLSearchParams(location.search).get('lg_demo');
  let demoSaved = false;
  try {
    if (demoParam === '1') localStorage.setItem('lg_demo', '1');
    else if (demoParam === '0') localStorage.removeItem('lg_demo');
    demoSaved = localStorage.getItem('lg_demo') === '1';
  } catch {}
  const DEMO = CFG.demo ? {
    viewers: 17, stock: 14,
    nextViewers: v => Math.min(31, Math.max(9, v + [-2, -1, -1, 1, 1, 2][Math.floor(Math.random() * 6)])),
    nextStock: n => (n > 6 && Math.random() < 0.3 ? n - 1 : n),
  } : null;

  // Delivery estimate like Apple's "Livraison : jeu. 25 sept." — etaDays working days, one more after the dispatch cut-off.
  const ETA = (() => { const d = new Date(); let n = (+CFG.etaDays || 2) + (CUTOFF && d.getHours() >= CUTOFF ? 1 : 0); while (n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d.toLocaleDateString('fr-FR', {weekday: 'short', day: 'numeric', month: 'short'}); })();

  // Deal countdown to the real end date set in the theme editor. Without one the clock stays hidden, except in the
  // developer preview, where it runs to local midnight like the prototype (at least 2 h, else the next midnight).
  const clock = $('[data-clock]');
  const demoEnd = now => { const e = new Date(now); e.setHours(24, 0, 0, 0); if (e - now < 2 * 3600e3) e.setDate(e.getDate() + 1); return e; };
  const realEnd = clock && clock.getAttribute('datetime') ? new Date(clock.getAttribute('datetime')) : null;
  if (clock) {
    let end = realEnd || demoEnd(new Date());
    clock.parentElement.hidden = false;
    let shown = '';
    const showClock = txt => {
      if (txt.length !== shown.length) clock.innerHTML = [...txt].map(c => `<span>${c}</span>`).join('');
      else [...txt].forEach((c, i) => { if (c !== shown[i]) { const d = clock.children[i]; d.textContent = c; d.classList.remove('roll'); void d.offsetWidth; d.classList.add('roll'); } });
      shown = txt;
    };
    (function tick() {
      let ms = end - Date.now();
      if (!realEnd && ms <= 0) { end = demoEnd(new Date()); ms = end - Date.now(); }
      if (isNaN(ms) || ms <= 0) { clock.parentElement.hidden = true; return; }
      const s = Math.floor(ms / 1000);
      showClock(`${pad(Math.floor(s / 3600))}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}`);
      setTimeout(tick, 1000 - Date.now() % 1000);
    })();
  }

  // Dispatch cut-off, Apple-style: before CUTOFF on a working day the order leaves today, otherwise on the next working day.
  const dispatch = $('[data-dispatch]');
  if (dispatch && CUTOFF) (function cutoff() {
    const now = new Date(), end = new Date(now); end.setHours(CUTOFF, 0, 0, 0);
    if (now.getDay() % 6 && now < end) {
      const m = Math.ceil((end - now) / 60000);
      dispatch.textContent = `Commandez dans les ${m >= 60 ? `${Math.floor(m / 60)} h ` : ''}${pad(m % 60)} min : expédition prévue aujourd’hui`;
    } else {
      const d = new Date(now); do d.setDate(d.getDate() + 1); while (!(d.getDay() % 6));
      const t = new Date(now); t.setDate(t.getDate() + 1); const tomorrow = d.toDateString() === t.toDateString();
      dispatch.textContent = `Commandez aujourd’hui : expédition prévue ${tomorrow ? 'demain' : d.toLocaleDateString('fr-FR', {weekday: 'long'})}`;
    }
    dispatch.hidden = false;
    setTimeout(cutoff, 30e3);
  })();

  // Signals row. Stock: real inventory of the chosen variant, only when Shopify tracks it and it is under the threshold.
  // Viewers: no live source yet, so only the developer preview fills it (DEMO). Wire a real presence count here.
  const signals = $('[data-signals]'), stockEl = $('[data-stock]'), viewersEl = $('[data-viewers]');
  const roll = el => { const b = el.querySelector('b'); if (b && !calm) { b.classList.remove('roll'); void b.offsetWidth; b.classList.add('roll'); } };
  const updSignals = () => { signals.hidden = stockEl.hidden && viewersEl.hidden; };
  const showStock = b => {
    const n = DEMO ? DEMO.stock : b && b.stock, low = n != null && n > 0 && (DEMO ? n <= 20 : CFG.lowStock > 0 && n <= CFG.lowStock);
    stockEl.hidden = !low;
    if (low) { stockEl.innerHTML = `<span>Plus que <b>${n}</b> en stock</span>`; roll(stockEl); }
    updSignals();
  };
  const showViewers = v => { viewersEl.hidden = v == null; if (v != null) { viewersEl.innerHTML = `<i class="dot" aria-hidden="true"></i><span><b>${v}</b> personnes regardent ce produit</span>`; roll(viewersEl); } updSignals(); };
  if (DEMO) (function drift() {
    showViewers(DEMO.viewers); DEMO.viewers = DEMO.nextViewers(DEMO.viewers);
    const n = DEMO.nextStock(DEMO.stock); if (n !== DEMO.stock) { DEMO.stock = n; showStock(); }
    setTimeout(drift, 4000 + Math.random() * 5000);
  })();

  // Images fade in once decoded
  $$('.fade').forEach(i => i.complete && i.naturalWidth ? i.classList.add('ok') : i.addEventListener('load', () => i.classList.add('ok'), {once: true}));

  // Scroll reveal (once)
  const rio = new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); o.unobserve(e.target); } }), {rootMargin: '0px 0px -8% 0px'});
  $$('.reveal').forEach(el => rio.observe(el));

  // Segmented controls: one thumb slides to the pressed option
  const segs = $$('[data-seg]');
  const moveThumbs = () => segs.forEach(seg => {
    const b = seg.querySelector('[aria-pressed="true"]'), t = seg.querySelector('.seg-thumb');
    if (!b || !t) return;
    t.style.cssText = `width:${b.offsetWidth}px;height:${b.offsetHeight}px;transform:translate(${b.offsetLeft}px,${b.offsetTop}px)`;
  });
  // rAF-batched: resizing inside the observer callback triggered "ResizeObserver loop completed" errors
  let thumbRaf = 0;
  // the buttons themselves too: a late web font (FB/IG in-app) changes their height without resizing body, leaving the thumb sticking out
  if (window.ResizeObserver) { const ro = new ResizeObserver(() => { if (!thumbRaf) thumbRaf = requestAnimationFrame(() => { thumbRaf = 0; moveThumbs(); }); }); ro.observe(document.body); segs.forEach(s => { ro.observe(s); s.querySelectorAll('button').forEach(b => ro.observe(b)); }); }
  if (document.fonts) document.fonts.ready.then(moveThumbs);

  // Video posters load lazily: once a video nears the screen, or its gallery slide is active or next up
  const wake = v => { if (v && v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; } };
  const pio = new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { wake(e.target); o.unobserve(e.target); } }), {rootMargin: '200px 0px'});
  $$('video[data-poster]').forEach(v => pio.observe(v));

  // Gallery: native scroll-snap does the swiping; JS only syncs tabs and arrows.
  const track = $('[data-track]'), slides = [...track.children].filter(el => el.matches('.slide')), tabs = $$('[data-shot]');
  const prev = $('[data-prev]'), next = $('[data-next]');
  let cur = 0, wanted = null;
  const step = () => slides[1].offsetLeft - slides[0].offsetLeft;
  const tabRow = $('[data-tabs]');
  const mark = i => {
    if (i === cur) return;
    cur = i;
    [slides[i], slides[i + 1]].forEach(s => s && wake(s.querySelector('video')));
    { // keep the chosen tab in view inside its own row, never scroll the page
      const t = tabs[i]; tabRow.scrollTo({left: t.offsetLeft - (tabRow.clientWidth - t.offsetWidth) / 2, behavior: calm ? 'auto' : 'smooth'});
    }
    tabs.forEach((t, j) => t.setAttribute('aria-pressed', String(j === i)));
    prev.disabled = i === 0; next.disabled = i === slides.length - 1;
    moveThumbs();
  };
  // A click sets one target; scroll positions passed on the way there are ignored, so the thumb glides once
  let lock = false, lockT;
  const release = ms => { clearTimeout(lockT); lockT = setTimeout(() => lock = false, ms); };
  const go = i => { wanted = i; lock = true; release(900); track.scrollTo({left: i * step()}); mark(i); };
  tabs.forEach((t, i) => t.addEventListener('click', () => go(i)));
  prev.addEventListener('click', () => go(Math.max(cur - 1, 0)));
  next.addEventListener('click', () => go(Math.min(cur + 1, slides.length - 1)));
  // Active slide follows the scroll position. Near the end several slides fit at once, so a clicked target wins there.
  track.addEventListener('scroll', () => {
    if (lock) return release(160);
    const i = Math.round(track.scrollLeft / step()), atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    mark(atEnd && wanted > i ? wanted : i);
  }, {passive: true});
  ['pointerdown', 'wheel'].forEach(ev => track.addEventListener(ev, () => { wanted = null; lock = false; }, {passive: true}));

  // Videos: autoplay muted while on screen, pause when off screen. The button always works, also when the
  // browser blocks autoplay or the visitor prefers reduced motion (then nothing starts by itself).
  $$('.vwrap').forEach(w => {
    const v = w.querySelector('video'), btn = w.querySelector('.vbtn');
    let userPaused = calm;
    const render = () => { w.classList.toggle('paused', v.paused); btn.setAttribute('aria-label', v.paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause'); };
    v.addEventListener('play', render); v.addEventListener('pause', render);
    btn.addEventListener('click', () => { userPaused = !v.paused; userPaused ? v.pause() : v.play().catch(render); });
    new IntersectionObserver(([e]) => e.isIntersecting && !userPaused ? v.play().catch(render) : v.pause(), {threshold: .5}).observe(v);
    render();
  });

  // UGC reel: Apple-style paddles, only shown when the row actually scrolls
  const uRow = $('[data-ugc-row]'), uNav = $('[data-ugc-nav]'), uPrev = $('[data-ugc-prev]'), uNext = $('[data-ugc-next]');
  const uUpd = () => { const max = uRow.scrollWidth - uRow.clientWidth; uNav.hidden = max < 4; uPrev.disabled = uRow.scrollLeft < 4; uNext.disabled = uRow.scrollLeft > max - 4; };
  const uBy = d => uRow.scrollBy({left: d * (uRow.firstElementChild.offsetWidth + 12), behavior: calm ? 'auto' : 'smooth'});
  uPrev.addEventListener('click', () => uBy(-1)); uNext.addEventListener('click', () => uBy(1));
  let uRaf = 0;  // rAF-batched, same reason as thumbRaf
  uRow.addEventListener('scroll', uUpd, {passive: true}); if (window.ResizeObserver) new ResizeObserver(() => { if (!uRaf) uRaf = requestAnimationFrame(() => { uRaf = 0; uUpd(); }); }).observe(uRow); else uUpd();
  // all reel posters at once when the row nears the screen, so fast swiping never shows an empty card
  new IntersectionObserver((es, o) => { if (es.some(e => e.isIntersecting)) { uRow.querySelectorAll('video').forEach(wake); o.disconnect(); } }, {rootMargin: '400px 0px'}).observe(uRow);

  // Microsoft Clarity (app embed) events for funnels; clarity() queues until its script loads, absent = no-op.
  const clarityEvent = (name, lot) => { try { if (window.clarity) { if (lot) clarity('set', 'lot', String(lot)); clarity('event', name); } } catch {} };

  // Bundle choice, mirrored in the buy panel and the floating bar; each lot is a Shopify variant
  const variantInput = $('[data-variant-input]');
  const pressed = $('.bundle-segment [aria-pressed="true"]');
  let qty = pressed ? +pressed.dataset.qty : +Object.keys(BUNDLES)[0];
  const addLabel = (el, b) => !b.available ? 'Épuisé' : 'AJOUTER AU PANIER';
  function sync(q) {
    const b = BUNDLES[q]; if (!b) return;
    const changed = q !== qty; qty = q;
    const {price, dur = ''} = b, per = Math.round(price / q), save = b.compare ? b.compare - price : 0;
    $$('[data-bundle]').forEach(el => el.setAttribute('aria-pressed', String(+el.dataset.qty === q)));
    moveThumbs();
    set('[data-live-price]', euro(price));
    if (changed) { const p = $('[data-live-price]'); p.classList.remove('tick'); void p.offsetWidth; p.classList.add('tick'); }
    set('[data-pitch]', b.pitch || '');
    const label = q === 1 ? '' : b.tag ? `<b>${b.tag}</b> · ` : '';
    $('[data-note]').innerHTML = q === 1 ? `${dur} · ${euro(per)}/ampoule` : `${label}${euro(per)}/ampoule${save > 0 ? ` · <i class="save">Économisez ${euro(save)}</i>` : ''}`;
    // Only the free delivery stays next to the button; delivery times are answered in the FAQ.
    set('[data-ship]', freeFor(price) ? 'Livraison offerte' : `Livraison offerte dès ${euro(FREE_SHIP)}`);
    set('[data-sticky-qty]', ampoules(q)); set('[data-sticky-price]', euro(price));
    set('[data-sticky-was]', save > 0 ? euro(b.compare) : '');
    // Floating bar: the deal in words ("2 achetées + 1 offerte"), the duration drops first on narrow phones.
    const [paid, free] = (b.offer || '').split(' + ');
    $$('[data-sticky-meta]').forEach(el => el.innerHTML = free ? `<i class="save">${paid} achetées + ${free} offerte${free > 1 ? 's' : ''}</i>${dur ? `<span class="sc-dur"> · ${dur}</span>` : ''}` : `<span class="sc-dur">${dur}</span>`);
    $$('[data-add]').forEach(el => { el.textContent = addLabel(el, b); el.disabled = !b.available; });
    if (variantInput) variantInput.value = b.id;
    showStock(b);
    if (changed && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', b.id); history.replaceState(history.state, '', u); }
  }
  $$('[data-bundle]').forEach(b => b.addEventListener('click', () => { sync(+b.dataset.qty); clarityEvent('lot_gekozen', +b.dataset.qty); }));

  // Cart drawer on the Shopify AJAX cart
  const drawer = $('[data-drawer]'), lines = $('[data-lines]'), badge = $('[data-cart-count]'), errEl = $('[data-cart-error]');
  const root = (CFG.root || '/').endsWith('/') ? (CFG.root || '/') : CFG.root + '/';
  const api = (path, body) => fetch(root + path, {credentials: 'same-origin', cache: 'no-store', ...(body ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)} : {headers: {Accept: 'application/json'}})})
    .then(async r => { const data = await r.json().catch(() => ({})); if (!r.ok) throw new Error(data.description || data.message || 'Une erreur est survenue. Réessayez.'); return data; });
  const esc = s => String(s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
  const showError = msg => { errEl.textContent = msg || ''; errEl.hidden = !msg; };
  // What a cart line saves against buying the same ampoules one by one (0 when it is not a lot on offer).
  const lineRef = it => { const b = byVariant[it.variant_id] || upsellByVariant[it.variant_id] || relatedByVariant[it.variant_id]; return b && b.compare ? b.compare * it.quantity : 0; };
  const lineSaving = it => Math.max(0, lineRef(it) - it.final_line_price);
  const cartOffer = $('[data-cart-offer]');
  const cartOfferTitle = cartOffer.querySelector('[data-cart-offer-title]');
  const cartOfferDetail = cartOffer.querySelector('[data-cart-offer-detail]');
  const cartOfferClock = cartOffer.querySelector('[data-cart-offer-clock]');
  const cartCountdownKey = 'lg_cart_countdown_ends_at_v1';
  const cartCountdownDuration = 5 * 60 * 1000;
  let cartCountdownEndsAt = 0;
  let cartCountdownInterval = null;
  try {
    const saved = Number(localStorage.getItem(cartCountdownKey));
    if (Number.isFinite(saved) && saved > 0 && saved <= Date.now() + cartCountdownDuration) cartCountdownEndsAt = saved;
  } catch {}
  function updateCartCountdown() {
    if (cartOffer.hidden) return;
    const remaining = Math.max(0, Math.ceil((cartCountdownEndsAt - Date.now()) / 1000));
    const title = remaining ? cartOffer.dataset.prompt : cartOffer.dataset.ready;
    if (cartOfferTitle.textContent !== title) cartOfferTitle.textContent = title;
    cartOfferClock.hidden = !remaining;
    if (remaining) cartOfferClock.textContent = `${pad(Math.floor(remaining / 60))}:${pad(remaining % 60)}`;
    else { clearInterval(cartCountdownInterval); cartCountdownInterval = null; }
  }
  // Names the offers in the cart ("Offre 2 + 1 appliquée"); the amount saved is shown once, in the totals.
  const offerDetail = items => {
    const offered = items.filter(it => lineSaving(it) > 0).map(it => byVariant[it.variant_id]).filter(b => b && b.offer).sort((a, b) => a.qty - b.qty);
    const names = [...new Set(offered.map(b => b.offer))];
    if (!names.length) return cartOffer.dataset.defaultDetail;
    return names.length === 1 ? `Offre ${names[0]} appliquée` : `Offres ${names.slice(0, -1).join(', ')} et ${names[names.length - 1]} appliquées`;
  };
  function renderCartOffer(cart, items) {
    cartOffer.hidden = !items.length;
    if (!items.length) {
      clearInterval(cartCountdownInterval);
      cartCountdownInterval = null;
      if (cart.item_count === 0) {
        cartCountdownEndsAt = 0;
        try { localStorage.removeItem(cartCountdownKey); } catch {}
      }
      return;
    }
    if (!cartCountdownEndsAt) {
      cartCountdownEndsAt = Date.now() + cartCountdownDuration;
      try { localStorage.setItem(cartCountdownKey, String(cartCountdownEndsAt)); } catch {}
    }
    const detail = offerDetail(items);
    if (cartOfferDetail.textContent !== detail) cartOfferDetail.textContent = detail;
    updateCartCountdown();
    if (cartCountdownEndsAt > Date.now() && !cartCountdownInterval) cartCountdownInterval = setInterval(updateCartCountdown, 1000);
  }
  window.addEventListener('pagehide', () => { clearInterval(cartCountdownInterval); cartCountdownInterval = null; });
  window.addEventListener('pageshow', () => renderCartOffer(cartState, cartState.items || []));
  const TAG_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 2.5h5.2l6 6-5.2 5.2-6-6z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="5.4" cy="5.4" r="1.1" fill="currentColor"/></svg>';
  let cartState = {items: [], total_price: 0};

  const upsellPanel = $('[data-upsells]'), upsellList = $('[data-upsell-list]'), upsellStatus = $('[data-upsell-status]');
  let upsellBusy = false;
  const upsellCards = UPSELLS.map(p => {
    const discount = p.compare > p.price ? Math.round((p.compare - p.price) * 100 / p.compare) : 0;
    const detail = p.detail ? esc(p.detail) : discount ? 'Soin de nuit' : 'Tester à 5 €';
    return `<article class="upsell-card"><img src="${esc(p.image)}" alt="" width="56" height="70" loading="lazy"><div><h4>${esc(p.shortTitle || p.title)}</h4><p class="upsell-detail">${detail}</p><div class="upsell-foot"><span class="upsell-price">${discount ? `<s>${euro(p.compare)}</s>` : ''}${euro(p.price)}${discount ? `<span class="upsell-discount">−${discount} %</span>` : ''}</span><button class="upsell-add" type="button" data-upsell-add="${p.id}" aria-label="${esc(upsellLabels.add)} — ${esc(p.title)}">${esc(upsellLabels.add)}</button></div></div></article>`;
  }).join('');
  if (upsellList) upsellList.innerHTML = upsellCards;
  function renderUpsells(items) {
    if (!upsellPanel) return;
    const hasAmpoule = items.some(it => byVariant[it.variant_id] && it.quantity > 0);
    upsellPanel.hidden = !hasAmpoule || !UPSELLS.length;
    upsellList.querySelectorAll('[data-upsell-add]').forEach(btn => {
      const added = items.some(it => String(it.variant_id) === btn.dataset.upsellAdd && it.quantity > 0);
      btn.disabled = added || upsellBusy;
      btn.textContent = added ? upsellLabels.added : upsellBusy ? upsellLabels.adding : upsellLabels.add;
    });
  }
  if (upsellList) upsellList.addEventListener('click', async e => {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled || upsellBusy || !cartState.items.some(it => byVariant[it.variant_id])) return;
    const p = upsellByVariant[btn.dataset.upsellAdd];
    if (!p) return;
    upsellBusy = true;
    upsellStatus.textContent = '';
    renderUpsells(cartState.items);
    const prev = cartState;
    try {
      await enqueue(async () => { await api('cart/add.js', {items: [{id: p.id, quantity: 1}]}); return api('cart.js'); }, prev);
    } finally {
      upsellBusy = false;
      renderUpsells(cartState.items);
      if (cartState.items.some(it => it.variant_id === p.id)) upsellStatus.textContent = `${p.shortTitle || p.title} — ${upsellLabels.added}`;
      else upsellStatus.textContent = upsellLabels.error;
    }
  });

  function renderCart(cart = cartState) {
    cartState = cart;
    const items = cart.items || [], total = cart.total_price || 0;
    renderCartOffer(cart, items);
    renderUpsells(items);
    renderRelated(items);
    const count = items.reduce((s, it) => s + it.quantity * (byVariant[it.variant_id] ? byVariant[it.variant_id].qty : 1), 0);
    if (badge.textContent !== String(count)) { badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); }
    badge.textContent = count; badge.hidden = !count;
    $('[data-cart]').setAttribute('aria-label', count ? `Panier, ${ampoules(count)}` : 'Panier');
    lines.innerHTML = items.length ? items.map(it => {
      const b = byVariant[it.variant_id], saving = lineSaving(it);
      const title = b ? it.product_title : it.product_title + (it.variant_title && !['Default Title', 'Titre par défaut'].includes(it.variant_title) ? ` · ${it.variant_title}` : '');
      const tag = b && saving > 0 && b.badge ? `<span class="offer-tag">${TAG_ICON}${esc(b.badge)}</span>` : '';
      const meta = !b ? '' : saving > 0 && b.note ? b.note : `${ampoules(b.qty)}${b.dur ? ` · ${b.dur}` : ''}`;
      const was = saving > 0 ? `<s class="was"><span class="visually-hidden">Prix sans l’offre : </span>${euro(lineRef(it))}</s>` : '';
      const img = it.image ? ` style="background-image:url('${esc(it.image)}')"` : '';
      const name = b ? `un lot de ${ampoules(b.qty)}` : esc(it.product_title);
      return `<li class="line"><span class="thumb" aria-hidden="true"${img}></span><div><b>${esc(title)}</b>${tag}${meta ? `<small>${esc(meta)}</small>` : ''}<div class="stepper"><button type="button" data-step="-1" data-key="${esc(it.key)}" data-q="${it.quantity}" aria-label="Retirer ${name}">−</button><span>${it.quantity}</span><button type="button" data-step="1" data-key="${esc(it.key)}" data-q="${it.quantity}" aria-label="Ajouter ${name}">+</button></div></div><span class="lp">${was}<b>${euro(it.final_line_price)}</b></span></li>`;
    }).join('') : '<li class="empty">Votre panier est vide.</li>';
    const saved = items.reduce((s, it) => s + lineSaving(it), 0);
    $('[data-save-row]').hidden = !saved;
    set('[data-save-total]', saved ? `−${euro(saved)}` : '');
    set('[data-ship-cart]', !total ? '—' : freeFor(total) ? 'Offerte' : 'Calculée au paiement');
    set('[data-hint]', total && !freeFor(total) ? `Plus que ${euro(FREE_SHIP - total)} pour la livraison offerte.` : '');
    set('[data-sub]', euro(total));
    $('[data-checkout]').disabled = !total;
  }
  // Optimistic updates: the drawer and totals change on the click itself, like the prototype, and Shopify is updated
  // in the background. Requests run one after another; once the last one settles the real cart replaces the estimate,
  // and a failed request rolls back to the server's cart with the error shown in the drawer.
  const withTotal = items => ({items, total_price: items.reduce((s, it) => s + it.final_line_price, 0)});
  let queue = Promise.resolve(), inflight = 0, cartRevision = 0;
  const refreshCart = () => {
    const revision = cartRevision;
    return api('cart.js').then(cart => {
      if (!inflight && revision === cartRevision) renderCart(cart);
    }).catch(() => {});
  };
  const enqueue = (request, rollback) => {
    inflight++;
    cartRevision++;
    const job = queue.then(request).then(cart => ({cart}), err => ({err}));
    queue = job.then(() => {});
    return job.then(async ({cart, err}) => {
      if (err) { showError(err.message); cart = await api('cart.js').catch(() => rollback); }
      if (!--inflight) renderCart(cart);
      return cart;
    });
  };
  lines.addEventListener('click', e => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    const {key, step} = b.dataset, quantity = Math.max(0, +b.dataset.q + +step), prev = cartState;
    if (upsellStatus) upsellStatus.textContent = '';
    showError('');
    renderCart(withTotal(prev.items.flatMap(it => it.key !== key ? [it] : quantity ? [{...it, quantity, final_line_price: it.final_price * quantity}] : [])));
    (lines.querySelector(`[data-step="${step}"][data-key="${CSS.escape(key)}"]`) || drawer.querySelector('.x')).focus();
    // A line added a moment ago still has a temporary key; Shopify then gets the variant id instead of the line key.
    enqueue(() => api('cart/change.js', {id: key.startsWith('pending:') ? +key.slice(8) : key, quantity}), prev);
  });
  // On touch screens the drawer slides in under the finger that just tapped "Ajouter"; a quick second tap would hit
  // "Continuer mes achats" or "+" in the sheet. Taps inside the drawer are ignored while it slides in.
  let openedAt = 0;
  const openDrawer = () => {
    if (drawer.open) return;
    openedAt = performance.now();
    try { drawer.showModal(); } catch { drawer.setAttribute('open', ''); }
  };
  drawer.addEventListener('click', e => { if (performance.now() - openedAt < 600) { e.preventDefault(); e.stopPropagation(); } }, true);
  const openCart = () => { renderCart(); openDrawer(); };
  const add = () => {
    const b = BUNDLES[qty]; if (!b || !b.available) return;
    clarityEvent('in_winkelwagen', qty);
    if (!drawer.showModal && form) { variantInput.value = b.id; return form.submit(); }
    // The cart holds the chosen lot once: a second tap or a return visit used to make it 2x (EUR 119,90 at checkout,
    // seen in abandoned checkouts). Another lot replaces the earlier one; "+" in the drawer still allows more on purpose.
    const lotIds = Object.values(BUNDLES).map(x => x.id), prev = cartState;
    const items = prev.items.filter(it => !lotIds.includes(it.variant_id) || it.variant_id === b.id).map(it => ({...it})), line = items.find(it => it.variant_id === b.id);
    if (line) { line.quantity = 1; line.final_line_price = line.final_price; }
    else items.push({key: `pending:${b.id}`, variant_id: b.id, product_title: CFG.productTitle, quantity: 1, final_price: b.price, final_line_price: b.price, image: null});
    enqueue(() => api('cart/update.js', {updates: Object.fromEntries(lotIds.map(id => [id, id === b.id ? 1 : 0]))}).then(() => api('cart.js')), prev);
    showError(''); renderCart(withTotal(items)); openDrawer();
  };
  const form = $('[data-add-form]');
  if (form) form.addEventListener('submit', e => { e.preventDefault(); add(); });
  $$('[data-add="short"]').forEach(el => el.addEventListener('click', add));
  $('[data-cart]').addEventListener('click', () => { clarityEvent('winkelwagen_open'); showError(''); openCart(); refreshCart(); });
  drawer.addEventListener('click', e => { if (e.target === drawer) drawer.close(); });
  // Checkout waits for queued cart updates so nothing added a moment ago is missing.
  $('[data-checkout]').addEventListener('click', () => { clarityEvent('naar_checkout'); queue.then(() => { window.location.href = root + 'checkout'; }); });

  function renderRelated(items) {
    relatedForms.forEach(form => {
      const btn = form.querySelector('[data-related-add]'), p = relatedByVariant[form.dataset.relatedId];
      if (!p || !btn) return;
      const added = items.some(it => it.variant_id === p.id && it.quantity > 0);
      const status = form.querySelector('[data-related-status]');
      if (!added && status.textContent === upsellLabels.added) status.textContent = '';
      btn.disabled = !p.available || added || relatedPending.has(p.id);
      btn.textContent = !p.available ? btn.textContent : added ? upsellLabels.added : relatedPending.has(p.id) ? upsellLabels.adding : btn.dataset.label;
    });
  }
  relatedForms.forEach(form => form.addEventListener('submit', async e => {
    e.preventDefault();
    const p = relatedByVariant[form.dataset.relatedId], btn = form.querySelector('[data-related-add]'), status = form.querySelector('[data-related-status]');
    if (!p || !p.available || btn.disabled || relatedPending.has(p.id)) return;
    relatedPending.add(p.id);
    status.textContent = '';
    showError('');
    renderRelated(cartState.items);
    const prev = cartState;
    try {
      const cart = await enqueue(async () => { await api('cart/add.js', {items: [{id: p.id, quantity: 1}]}); return api('cart.js'); }, prev);
      const added = cart.items.some(it => it.variant_id === p.id && it.quantity > 0);
      status.textContent = added ? upsellLabels.added : upsellLabels.error;
      if (added) { clarityEvent('soin_complementaire_ajoute'); openDrawer(); }
    } finally {
      relatedPending.delete(p.id);
      renderRelated(cartState.items);
    }
  }));

  refreshCart();

  // Floating buy bar: visible whenever neither the product intro nor the buy panel is on screen.
  const sticky = $('[data-sticky]'), onScreen = new Set();
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => e.isIntersecting ? onScreen.add(e.target) : onScreen.delete(e.target));
    sticky.classList.toggle('show', !onScreen.size);
  });
  $$('[data-hide-sticky]').forEach(el => io.observe(el));

  sync(qty);
  requestAnimationFrame(() => document.documentElement.classList.add('seg-ready'));
})();

